module.exports = __webpack_public_path__ + "media/src/images/top_covers/year-end_image_01-3397326f0a1e2fea12da8a672ee5968f.png";